import React, {useMemo, useState} from 'react';
import {useLocalization} from '@progress/kendo-react-intl';

// css
import '../../assets/css/WhatsNew.css';

// kendoreact
import {Dialog} from '@progress/kendo-react-dialogs';
import {Tooltip} from '@progress/kendo-react-tooltip';

// components
import {BullhornIcon, IconButton} from './icons';

// multilingual
import {whatsNewTitleKey} from '../../assets/text/MultilingualText';


const isPromptInDateRange = (prompt, now) => {
    const startDate = prompt?.start_date ? new Date(prompt.start_date) : null;
    const endDate = prompt?.end_date ? new Date(prompt.end_date) : null;

    const isStartValid = !startDate || (!Number.isNaN(startDate.getTime()) && startDate <= now);
    const isEndValid = !endDate || (!Number.isNaN(endDate.getTime()) && endDate >= now);

    return isStartValid && isEndValid;
};


export default function WhatsNew({globalConfig, promptName}) {
    const localization = useLocalization();
    const [showDialog, setShowDialog] = useState(false);
    const whatsNewTitle = localization.toLanguageString(whatsNewTitleKey, "What's New");

    const prompts = useMemo(() => {
        const now = new Date();
        const allPrompts = globalConfig?.prompts || [];
        const activePrompts = allPrompts.filter((prompt) => prompt?.enabled === 'Y' && isPromptInDateRange(prompt, now));

        const nameFiltered = promptName
            ? activePrompts.filter((prompt) => prompt.prompt_name === promptName)
            : activePrompts.filter((prompt) => (prompt.prompt_name || '').startsWith('WHATS-NEW'));

        const fallback = nameFiltered.length
            ? nameFiltered
            : activePrompts.filter((prompt) => (prompt.prompt_name || '').startsWith('WHATS-NEW'));

        return fallback.sort((a, b) => new Date(b.start_date || 0) - new Date(a.start_date || 0));
    }, [globalConfig, promptName]);

    if (!prompts.length) {
        return null;
    }

    const modalTitle = prompts.length > 0 ? prompts[0].prompt_title : whatsNewTitle;

    return (
        <>
            <Tooltip
                anchorElement="target"
                showCallout={true}
                parentTitle={true}
                position="left"
            >
                <div className={'whats-new-anchor'}>
                    <IconButton
                        title={whatsNewTitle}
                        className={'whats-new-button p-2'}
                        Icon={BullhornIcon}
                        aria-label={whatsNewTitle}
                        fillMode={'outline'}
                        size={'large'}
                        onClick={() => setShowDialog(true)}
                    />
                </div>
            </Tooltip>
            {showDialog && (
                <Dialog className={'whats-new-modal ksm-dialog'} title={modalTitle} onClose={() => setShowDialog(false)}>
                    <div className={'whats-new-list'}>
                        {prompts.map((prompt) => (
                            <div
                                key={`${prompt.prompt_name}-${prompt.start_date || ''}-${prompt.end_date || ''}`}
                                className={'whats-new-item'}
                            >
                                <div dangerouslySetInnerHTML={{__html: prompt.prompt_message || ''}}/>
                            </div>
                        ))}
                    </div>
                </Dialog>
            )}
        </>
    );
}
